import React, { useEffect, useState } from 'react';

import axios from 'axios';

import { useNavigate, useParams } from 'react-router-dom';
import { useAuthContext } from '../../hooks/useAuthContext';
import { ApiConnectionString } from '../../constants/ApiConntection';

export default function ClubPolicyPage({ }) {
    const {clubId} = useParams()
    const [clubName,setClubName] = useState('')
  const [content, setContent] = useState('');
  const [created, setCreated] = useState('');
  const [updated, setUpdated] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [policyAgreement, setPolicyAgreement] = useState(null);
  const [complete, setComplete] = useState(false);
const navi = useNavigate()
  const { user } = useAuthContext();

  const agreeToTerms = async () => {
    setLoading(true);
    try {
      const res = await axios.post(
        `${ApiConnectionString}/api/PolicyAgreement`,
        { clubId },
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (res.status === 200) {
        await fetchPolicy();
        setComplete(true);
      } else {
        setMessage('Could not record your agreement.');
      }
    } catch (err) {
      setMessage('An error occurred while agreeing to the policy.');
    } finally {
      setLoading(false);
    }
  };

  const fetchPolicy = async () => {
    try {
      if (user) {
        const policyResponse = await axios.get(
          `${ApiConnectionString}/api/PolicyAgreement/${user.id}/${clubId}`,
          {
            headers: { Authorization: `Bearer ${user.token}` },
          }
        );

        if (policyResponse.status === 200) {
         
          setPolicyAgreement(policyResponse.data);
        }
      }

      const res = await axios.get(
        `${ApiConnectionString}/api/clubPolicy/${clubId}`
      );

      if (res.status === 200) {
        setContent(res.data.policyContent || '');
        setCreated(res.data.policyCreated || null);
        setUpdated(res.data.policyUpdated || null);
        setClubName(res.data.clubName)
      }
    } catch (err) {
      setMessage('Failed to load policy.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
     fetchPolicy();
  }, []);

  return (
    <div className="container py-4 bg-white">
      <div className="blueBanner mb-4">
        <p className="fw-bold m-0 p-2 fontSize20">Club Policy</p>
      </div>

      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          {message && <p className="text-danger">{message}</p>}


                 <button
        className="floating-back-button"
        onClick={() => navi(`/club/${clubId}`)}
      >
        ← Back to Club Page
      </button>

             <p className="fw-bold mt-3">Club:</p>
          <p>{clubName}</p>

          <p className="fw-bold mt-3">Policy Content:</p>
          <p>{content}</p>

          {created && (
            <>
              <p className="fw-bold mt-3 mb-0">Created:</p>
              <p>{new Date(created).toLocaleString()}</p>
            </>
          )}

          {updated && (
            <>
              <p className="fw-bold mt-3 mb-0">Last Updated:</p>
              <p>{new Date(updated).toLocaleString()}</p>
            </>
          )}

          {user && updated && (!policyAgreement || updated > policyAgreement.policyUpdated) && !complete && (
            <button
              className="btn btn-danger mt-3"
              onClick={agreeToTerms}
            >
              Agree to Terms
            </button>
          )}

          {complete && <p className="text-success fw-bold mt-3">Thank you for agreeing to the policy.</p>}
        </>
      )}
    </div>
  );
}
